const livePrefectureRouter = {
  path: '/livePrefecture',
  component: () => import('@/layout'),
  children: [
    {
      path: '',
      name: 'livePrefecture',
      meta: { title: '视频专区' },
      component: () => import(/* webpackChunkName: "shop-live" */ '@/pages/livePrefecture')
    }
  ]
}

export default livePrefectureRouter
